<app-site-widget
	[title]="titleEbu"
	[tooltipText]="tooltipText"
	[elementId]="elementId"
	chartType="progress"
	widgetClass="height-100"
	[calculatePercentage]="true"
	[siteWidgetOptions]="{hasOperation: true, hasWorkingDaysCheckBox: true, hasDate: true, isSitePerformanceWidget: true, hasLithium: true, isCircleWidget: true}"
	[widgetOptions]="{hasExport: true, showTagFilter: false}"
	[data]="data"
	[hideTable]="true"
	[hideDevs]="true"
	[titleStyle]="true"
	[tagStyle]="true"
	[unitShow]="false"
	[fixedTo]="2"
	(eventEmit)="eventEmit($event)"
	[config]="config"
	[tableColumns]="tableColumns"
	[siteId]="siteId"
	[customerId]="customerId"
	[customerName]="customerName"
	[siteName]="siteName"
></app-site-widget>


